import api from '~/api';
import {
  DocumentResponse,
  DocumentTypeResponse,
  FetchUploadUrlForDocumentResponse,
} from '../dtos/documentResponse';
import { Document, DocumentType, UploadUrl } from '../model/document.model';

const DocumentTypeMap: Record<DocumentTypeResponse, DocumentType> = {
  w_9: DocumentType.w9,
  partner_referral_agreement: DocumentType.partnerReferralAgreement,
  other: DocumentType.other,
};

export async function getDocumentsRequest(partnerId: string): Promise<Document[]> {
  const response = await api.get<DocumentResponse[]>(`v1/partner/${partnerId}/documents`);

  return response.data.map(
    (document) => new Document(document.id, document.file_name, DocumentTypeMap[document.type])
  );
}

export async function downloadDocumentRequest(partnerId: string, documentId: string) {
  const response = await api.get<{ url: string }>(
    `v1/partner/${partnerId}/document/${documentId}/download`
  );

  return response.data.url;
}

export async function fetchUploadUrlForDocumentRequest(
  partnerId: string,
  file: File
): Promise<UploadUrl> {
  const { data } = await api.post<FetchUploadUrlForDocumentResponse>(
    `v1/partner/${partnerId}/document/upload_url`,
    { file_name: file.name, file_size: file.size }
  );

  return data.upload_url;
}

export async function uploadFileToObjectStorageRequest(url: string, file: File) {
  await api.put(url, file, {
    headers: { 'content-type': 'application/octet-stream' },
    withCredentials: false,
  });
}

export async function deleteDocumentRequest(partnerId: string, documentId: string) {
  await api.delete(`v1/partner/${partnerId}/document/${documentId}`);
}
